import axios from "axios";
import React, {useEffect, useState} from "react";
import { useLocation } from 'react-router-dom';

//export default function Prestacao({setOpenModal = false, prestacaoInfo = undefined}){
export default function Prestacao(){
    const location = useLocation();
    const { registro } = location.state || { registro: undefined };
    //console.log(registro);
    const [prestacaoInfo, setPrestacaoInfo] = useState(registro);
    //console.log(prestacaoInfo);

    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const [errorMessage, setErrorMessage] = useState('');
    //const [modal, setModal] = useState(false);
    const [file, setFile] = useState(null);
    const [PdfFile, setPdfFile] = useState({
        NomePdf: '',
        Arquivo: ''
    });
    const [uploadPDFStatus, setUploadPDFStatus] = useState('');
    const now = new Date();
    const [saldoMes, setSaldoMes] = useState(0);
    //var saldoMes = 0;
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    
    const uuid = customFormatDate.replace('-', '').replace(' ', '').replace(':', '').replace(':', '').replace('/', '').replace('/', '');    
    const [campos, setCampos] = useState({
        IdPrestacaoDeContas: 0,
        pdcMes: 0,
        pdcAno: 0,
        pdcMesAno: '',
        pdcReceitas: 0,
        pdcRendimentos: 0,
        pdcDespesas: 0,
        pdcFechamento: 0,
        pdcExtrato: '',
        pdcObservacoes: '',
        pdcStatus: 1,
        pdcCriadoPor: sessionStorage.nomeUsuario,
        pdcCriadoEm: customFormatDate,
        pdcAlteradoPor: sessionStorage.nomeUsuario,
        pdcAlteradoEm: customFormatDate,
        pdcCodigoGUID: ''
    });

    // if (modal) {
    //     document.body.classList.add('active-modal')
    // } else {
    //     document.body.classList.remove('active-modal')
    // }

    const anos = [];
    const dataAtual = new Date();
    
    const anoAtual = dataAtual.getFullYear();
    const mesAtual = dataAtual.getMonth();
    for (let ano = 2021; ano <= anoAtual; ano++){
        anos.push(ano);
    }
    campos['pdcMes'] = mesAtual;
    campos['pdcAno'] = anoAtual;

    if (prestacaoInfo !== undefined) {
        //console.log('CadastroInfo recebido no Cadastro.js:', cadastroInfo);
        preencherCampos();
    }

    function preencherCampos()
    {
        campos.IdPrestacaoDeContas = prestacaoInfo.IdPrestacaoDeContas;
        campos.pdcMes = prestacaoInfo.pdcMes;
        campos.pdcAno = prestacaoInfo.pdcAno;
        campos.pdcMesAno = prestacaoInfo.pdcMesAno;
        campos.pdcReceitas = prestacaoInfo.pdcReceitas;
        campos.pdcRendimentos = prestacaoInfo.pdcRendimentos;
        campos.pdcDespesas = prestacaoInfo.pdcDespesas;
        campos.pdcFechamento = prestacaoInfo.pdcFechamento;
        campos.pdcExtrato = prestacaoInfo.pdcExtrato;
        campos.pdcObservacoes = prestacaoInfo.pdcObservacoes;
        campos.pdcStatus = prestacaoInfo.pdcStatus;
        campos.pdcCriadoPor = prestacaoInfo.pdcCriadoPor;
        campos.pdcCriadoEm = prestacaoInfo.pdcCriadoEm;
        campos.pdcAlteradoPor = sessionStorage.nomeUsuario;
        campos.pdcAlteradoEm = customFormatDate;
        campos.pdcCodigoGUID = prestacaoInfo.pdcCodigoGUID;
    }

    // console.log(campos);
    // console.log(prestacaoInfo);

    function handleInputChange(event) {
        if(event.target.name === 'pdcDespesas' 
            || event.target.name === 'pdcReceitas'
            || event.target.name === 'pdcRendimentos'
            || event.target.name === 'pdcFechamento')
        {
            const rawValue = event.target.value;
            const numericValue = rawValue.replace(/[^0-9,.]/g, '').replace(',', '.'); 
            event.target.value = numericValue;//.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });            
        }

        campos[event.target.name] = event.target.value;
        if (prestacaoInfo){
            prestacaoInfo[event.target.name] = event.target.value;
        }
        
        // setSaldoMes((parseFloat(campos.pdcRendimentos) 
        // + parseFloat(campos.pdcReceitas)) 
        // - parseFloat(campos.pdcDespesas));

        //console.log(event.target.value);
    };

    var bloqueio = false;
    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    function handleFecharModal(){
        if(prestacaoInfo !== undefined || prestacaoInfo === false){
            //setOpenModal(false);
            window.history.back();
        }
        else {   
            //window.location.href = '/Associado'; 
            window.history.back();
        }
    };

    // criar function que salva os dados do form
    function handleFormSubmit(event) {
        
        event.preventDefault();
        //var tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        if (campos.pdcReceitas === null || campos.pdcReceitas === ''
            || campos.pdcRendimentos === null || campos.pdcRendimentos === ''
            || campos.pdcDespesas === null || campos.pdcDespesas === ''
            || campos.pdcFechamento === null || campos.pdcFechamento === ''
        ){
            setErrorMessage('Informe todos os campos de Valores');
            bloqueio = true;
            // console.log('aqui2')
            return;
        }
        else {
            bloqueio = false;
            setErrorMessage('');
            //console.log('aqui3')
        }

        let strMes = "";
        if (parseInt(campos.pdcMes) == 1){
            strMes = "JAN";
        }
        else if (parseInt(campos.pdcMes) == 2){
            strMes = "FEV";
        }
        else if (parseInt(campos.pdcMes) == 3){
            strMes = "MAR";
        }
        else if (parseInt(campos.pdcMes) == 4){
            strMes = "ABR";
        }
        else if (parseInt(campos.pdcMes) == 5){
            strMes = "MAI";
        }
        else if (parseInt(campos.pdcMes) == 6){
            strMes = "JUN";
        }
        else if (parseInt(campos.pdcMes) == 7){
            strMes = "JUL";
        }
        else if (parseInt(campos.pdcMes) == 8){
            strMes = "AGO";
        }
        else if (parseInt(campos.pdcMes) == 9){
            strMes = "SET";
        }
        else if (parseInt(campos.pdcMes) == 10){
            strMes = "OUT";
        }
        else if (parseInt(campos.pdcMes) == 11){
            strMes = "NOV";
        }
        else if (parseInt(campos.pdcMes) == 12){
            strMes = "DEZ";
        }

        campos.pdcMesAno = strMes + "/" + campos.pdcAno.toString();
        if (prestacaoInfo){
            prestacaoInfo.pdcMesAno = strMes + "/" + campos.pdcAno.toString();
        }
        // console.log(campos.pdcMesAno);
        // console.log(prestacaoInfo.pdcMesAno);
        // return;
        if (bloqueio === false)
        {
            console.log('aqui4')
            console.log(bloqueio)
            //return;
            bloqueio = true;
            if(file) {
                const formData = new FormData();
                formData.append('pdfFile', file)
                var reader = new FileReader();
                reader.readAsDataURL(file)
                reader.onload = function (fileLoadedEvent) {
                var srcData = fileLoadedEvent.target.result
                PdfFile['arquivo'] = srcData.split(',')[1]
                PdfFile['NomePDF'] = uuid + '_' + file.name
                setPdfFile(PdfFile)
                }

                axios
                .post(process.env.REACT_APP_API_URL +
                    '/routes.php?metodo=uploadExtrato', formData
                    , { headers: {
                        "X-Access-Token" : tokenAPI,
                        "Content-Type": "multipart/form-data; charset=UTF-8"
                    }}
                )
                .then (response => {
                    campos.pdcExtrato = response.data['filePath'];
                    if (prestacaoInfo){
                        prestacaoInfo.pdcExtrato = response.data['filePath'];
                    }
                    setUploadPDFStatus(`Sucesso: ${response.data.message}`);
                    bloqueio = false;
                    salvarPrestacao();
                })
                .catch(error => {
                    console.error('Houve um erro ao enviar o formulário:', error);
                    setUploadPDFStatus(`Erro ao enviar: ${error.response ? error.response.data.message : error.message}`);
                    bloqueio = true;
                    return;
                });
            } else {
                bloqueio = false;
                salvarPrestacao();
            }
        }
    }

    function salvarPrestacao(){
        if (bloqueio === false)
        {
            //console.log(campos.pdcMesAno);
            //return;
            if (campos.IdPrestacaoDeContas > 0) {
                console.log('Enviando atualização de registro');
                axios
                .post(process.env.REACT_APP_API_URL +
                    `/routes.php?metodo=atualizarPrestacao`, campos
                    , { headers: {
                        "X-Access-Token" : tokenAPI,
                        "Content-Type": "application/json; charset=UTF-8"
                    } }
                )
                .then(response => {
                    //console.log(response.data);
                    bloqueio = false;
                    alert(response.data['mensagem']);
                    window.location.href = '/#/Prestacoes'; // Redireciona para a página de associados
                })
                .catch(error => {
                    console.error('Houve um erro ao enviar o formulário:', error);
                    bloqueio = false;
                    alert('Houve um erro ao atualizar a prestação. Por favor, tente novamente.');
                });
            }
            else {
                //console.log('Criando novo cadastro');
                //return;
                axios.post(process.env.REACT_APP_API_URL +
                `/routes.php?metodo=novoCadastroPrestacao`, campos
                , { headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                } }
                )
                .then(response => {
                    //console.log(response.data);
                    bloqueio = false;
                    alert('Cadastro realizado com sucesso!');
                    window.location.href = '/#/Prestacoes'; // Redireciona para a página de associados
                })
                .catch(error => {
                    console.error('Houve um erro ao enviar o formulário:', error);
                    bloqueio = false;
                    alert('Houve um erro ao realizar o cadastro. Por favor, tente novamente.');
                });
            }
        }
    }

    var optionsMes = [
        { value: 1, label: 'JANEIRO'},
        { value: 2, label: 'FEVEREIRO'},
        { value: 3, label: 'MARÇO'},
        { value: 4, label: 'ABRIL'},
        { value: 5, label: 'MAIO'},
        { value: 6, label: 'JUNHO'},
        { value: 7, label: 'JULHO'},
        { value: 8, label: 'AGOSTO'},
        { value: 9, label: 'SETEMBRO'},
        { value: 10, label: 'OUTUBRO'},
        { value: 11, label: 'NOVEMBRO'},
        { value: 12, label: 'DEZEMBRO'},
    ];

    

    return (
        <>
            <main>
                <div>
                    <div className='d-flex w100 flex-column tdAlignLeft'>
                        <div className='text-align-leeft w80'>
                            <button
                                className="buttonModalPadraoLaranja fs11"
                                onClick={handleFecharModal}
                                style={{ cursor: 'pointer' }}
                                >
                                    VOLTAR
                            </button>
                        </div>
                    </div>
                    <form onSubmit={handleFormSubmit}>
                        <div className='headerMain'>
                            <label className='labelTitulo' >PRESTAÇÃO DE CONTAS</label>
                        </div>

                        <div className="d-flex w100 flex-column tdAlignLeft pb4">
                            
                            {/* MES E ANO */}
                            <div className="d-flex flex-row divForm">
                                {/* MES */}
                                <div className="w50">
                                    <div className='text-align-left divForm fs16'>
                                        <label>Mês</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <select
                                        defaultValue={campos.pdcMes}
                                        onChange={handleInputChange}
                                        className="pt1 pb1 fs12 w100 text-align-center" 
                                        required
                                        name="pdcMes"
                                        id="pdcMes"
                                        >
                                            {/* <option value="0">-- Mês --</option> */}
                                            {optionsMes.map((option) => (
                                                <option key={option.value} 
                                                value={option.value} 
                                                >
                                                    {option.label} 
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                {/* ANO */}
                                <div className="w50">
                                    <div className='text-align-left divForm fs16'>
                                        <label>Ano</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <select
                                        defaultValue={campos.pdcAno}
                                        onChange={handleInputChange}
                                        className="pt1 pb1 fs12 w100 text-align-center" 
                                        required
                                        name="pdcAno"
                                        id="pdcAno"
                                        >
                                            {/* <option value="0">-- ANO --</option> */}
                                            {
                                                anos.map((ano) => (
                                                    <option key={ano} 
                                                    value={ano}>{ano}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                            
                            {/* RECEITAS E DESPESAS */}
                            <div className="d-flex flex-row divForm">
                                {/* RECEITAS */}
                                <div className="w50">
                                    <div className='text-align-left divForm fs16'>
                                        <label>Receitas</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <input
                                        type="text"
                                        className="w100 p1 fs12 text-align-right"
                                        name="pdcReceitas"
                                        id="pdcReceitas"
                                        defaultValue={campos.pdcReceitas}
                                        onChange={handleInputChange}
                                        required
                                        />
                                    </div>
                                </div>
                                {/* DESPESAS */}
                                <div className="w50">
                                    <div className='text-align-left divForm fs16'>
                                        <label>Despesas</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <input
                                        type="text"
                                        className="w100 p1 fs12 text-align-right"
                                        name="pdcDespesas"
                                        id="pdcDespesas"
                                        defaultValue={campos.pdcDespesas}
                                        onChange={handleInputChange}
                                        required
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* RENDIMENTOS E SALDO MENSAL */}
                            <div className="d-flex flex-row divForm">
                                {/* RENDIMENTOS */}
                                <div className="w50">
                                    <div className='text-align-left divForm fs16'>
                                        <label>Rendimentos</label>
                                    </div>
                                    <div>
                                        <input
                                        type="text"
                                        className="w100 p1 fs12 text-align-right"
                                        name="pdcRendimentos"
                                        id="pdcRendimentos"
                                        defaultValue={campos.pdcRendimentos}
                                        onChange={handleInputChange}
                                        required
                                        />
                                    </div>
                                </div>
                                {/* SALDO DO MES */}
                                <div className="w50">
                                    <div className='text-align-left divForm fs16'>
                                        <label>Fechamento</label>
                                    </div>
                                    <div>
                                        <input
                                        type="text"
                                        className="w100 p1 fs12 text-align-right"
                                        name="pdcFechamento"
                                        id="pdcFechamento"
                                        defaultValue={campos.pdcFechamento}
                                        onChange={handleInputChange}
                                        required
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* OBSERVACOES */}
                            <div className="d-flex flex-column divForm">
                                <div className='text-align-left w100 divForm fs16'>
                                    <label>Observações</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input
                                    type="text"
                                    className="w100 p1 fs12 text-align-left"
                                    defaultValue={campos.pdcObservacoes}
                                    name="pdcObservacoes"
                                    id="pdcObservacoes"
                                    onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            {/* UPLOAD EXTRATO */}
                            <div className="d-flex flex-column divForm">
                                <div className='text-align-left w100 divForm fs16'>
                                    <label>Upload de Extrato</label>
                                </div>
                                <div className='text-align-center divForm w100 fs12'>
                                    <input
                                        type="file"
                                        name="uploadExtrato"
                                        className="p1 bgGray fs12 w100"
                                        id="uploadExtrato"
                                        accept=".csv,.pdf"
                                        onChange={handleFileChange} />
                                    <p>{uploadPDFStatus}</p>
                                </div>
                                <div className='text-align-left w100 divForm fs10'>
                                    <label>{campos.pdcExtrato.replace('uploads/extratos/', '')}</label>
                                </div>
                            </div>

                            {/* ALERTAS AVISOS */}
                            {errorMessage !== null && errorMessage !== '' ? (
                                <div className='text-align-left divForm fs10'>
                                    <span className="AlertPassword">
                                        {errorMessage}
                                    </span>
                                </div>
                            ) : (
                            <div></div>
                            )}
                            {parseInt(sessionStorage.pesAdmin) === 1 ? (
                            <div className='text-align-left mt2 mb4 divForm fs14'>
                                <button 
                                    className='buttonModalPadrao pt1 pb1 w100 fs14'
                                    type="submit">
                                    SALVAR PRESTAÇÃO
                                </button>
                            </div> ) : ('')}
                        </div>

                    </form>
                </div>
            </main>
        </>
    );
}